// extracted by mini-css-extract-plugin
export default {"docItemContainer":"docItemContainer_33ec","docItemCol":"docItemCol_3FnS","tocMobile":"tocMobile_3Hoh"};